/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Ai_Notice_Toggle_OnInputs */

const en_candidate_ai_notice_toggle_on = /** @type {(inputs: Candidate_Ai_Notice_Toggle_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Human review requested`)
};

const de_candidate_ai_notice_toggle_on = /** @type {(inputs: Candidate_Ai_Notice_Toggle_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menschliche Prüfung angefordert`)
};

const fr_candidate_ai_notice_toggle_on = /** @type {(inputs: Candidate_Ai_Notice_Toggle_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Examen humain demandé`)
};

const es_candidate_ai_notice_toggle_on = /** @type {(inputs: Candidate_Ai_Notice_Toggle_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisión humana solicitada`)
};

const it_candidate_ai_notice_toggle_on = /** @type {(inputs: Candidate_Ai_Notice_Toggle_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisione umana richiesta`)
};

const nl_candidate_ai_notice_toggle_on = /** @type {(inputs: Candidate_Ai_Notice_Toggle_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menselijke beoordeling aangevraagd`)
};

const pl_candidate_ai_notice_toggle_on = /** @type {(inputs: Candidate_Ai_Notice_Toggle_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poproszono o weryfikację przez człowieka`)
};

const fi_candidate_ai_notice_toggle_on = /** @type {(inputs: Candidate_Ai_Notice_Toggle_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihmisen tekemää tarkistusta pyydetty`)
};

const da_candidate_ai_notice_toggle_on = /** @type {(inputs: Candidate_Ai_Notice_Toggle_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menneskelig gennemgang anmodet`)
};

const sv_candidate_ai_notice_toggle_on = /** @type {(inputs: Candidate_Ai_Notice_Toggle_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mänsklig granskning begärd`)
};

/**
* | output |
* | --- |
* | "Human review requested" |
*
* @param {Candidate_Ai_Notice_Toggle_OnInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const candidate_ai_notice_toggle_on = /** @type {((inputs?: Candidate_Ai_Notice_Toggle_OnInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Ai_Notice_Toggle_OnInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_ai_notice_toggle_on(inputs)
	if (locale === "fr") return fr_candidate_ai_notice_toggle_on(inputs)
	if (locale === "es") return es_candidate_ai_notice_toggle_on(inputs)
	if (locale === "it") return it_candidate_ai_notice_toggle_on(inputs)
	if (locale === "nl") return nl_candidate_ai_notice_toggle_on(inputs)
	if (locale === "pl") return pl_candidate_ai_notice_toggle_on(inputs)
	if (locale === "fi") return fi_candidate_ai_notice_toggle_on(inputs)
	if (locale === "da") return da_candidate_ai_notice_toggle_on(inputs)
	if (locale === "sv") return sv_candidate_ai_notice_toggle_on(inputs)
	return en_candidate_ai_notice_toggle_on(inputs)
});